<template>
  <footer class="container text-center">
    <div class="cuscd-footer-wrap">
      <!-- studentchoice logo link -->
      <div class="row mb-3">
        <div class="cuscd-footer-col">
          <a href="https://studentchoice.org" :target="externalLinks ? '_blank' : undefined">
            <img :src="footerLogoUrl" alt="Student Choice" class="cuscd-footer-img" />
          </a>
        </div>
      </div>
      <!-- Info links -->
      <div class="row">
        <div class="cuscd-footer-col">
          <p class="cuscd-desc">
            <router-link :to="{ path: '/support', query: { lid: lid } }" target="_blank">
              Support
            </router-link>
            <!-- |
            <router-link
              to="/privacyPolicy"
              :target="externalLinks ? '_blank' : undefined"
            >
              Privacy
            </router-link>
            |
            <router-link
              to="/terms"
              :target="externalLinks ? '_blank' : undefined"
            >
              Terms
            </router-link>
            |
            <router-link
              to="/accessibility"
              :target="externalLinks ? '_blank' : undefined"
            >
              Accessibility
            </router-link> -->
          </p>
        </div>
      </div>
      <div class="row">
        <div class="cuscd-footer-col">
          <p class="cuscd-desc-sm">
            By using this site, you accept our
            <a :href="termsOfUseUrl" target="_blank">Terms of Use</a>
            <!-- <router-link
              to="/terms"
              :target="externalLinks ? '_blank' : undefined"
            >
              Terms of Use
            </router-link> -->
            and
            <router-link to="/privacyPolicy" target="_blank"> Privacy Policy </router-link>
          </p>
          <p class="cuscd-desc-sm">Student Choice &#169; {{ year }} All Rights Reserved</p>
          <a class="cuscd-desc-sm" target="_blank" href="https://nmlsconsumeraccess.org/">
            NMLS #2123582 – NMLS Consumer Access
          </a>
        </div>
        <ZohoSalesIQ :zohoSalesIQChatEnabled="zohoSalesIQChatEnabled" :branding="branding" />
      </div>
    </div>
  </footer>
</template>
<script setup lang="ts">
import { ImageConstants } from "@/config/constants";
import { computed } from "vue";
import { useStore } from "vuex";
import ZohoSalesIQ from "@/components/widgets/ZohoSalesIQ.vue";
import { LenderBranding } from "@/store/applicationsModule";

interface Props {
  externalLinks: boolean;
  lid: number;
}

const props = withDefaults(defineProps<Props>(), {
  externalLinks: false,
  lid: 0,
});

const store = useStore();
const identityUrl = computed(() => store.state.configuration?.identityUrl);
const termsOfUseUrl = computed<string>(() => "https://identity.studentchoice.org/Home/Terms");
const cdnImagesUrl = computed(() => store.getters["cdnImagesUrl"]);
const cuLogoUrl = computed(() => store.getters["cuLogoUrl"]);
const footerLogoUrl = computed<string>(
  () => `${cdnImagesUrl?.value}/${ImageConstants.FOOTER_LOGO}`,
);

const zohoSalesIQChatEnabled = computed<boolean>(() => {
  // if no branding
  if (!branding.value) {
    return false;
  }

  if (branding.value && branding.value.lenderId > 0) {
    return branding.value.zohoSalesIQChatEnabled;
  }

  return store.state.configuration?.zohoSalesIQChatEnabled;
});

const branding = computed<LenderBranding | undefined>(
  () => store.getters["applicationsModule/Branding"],
);

const year = computed<number>(() => new Date().getFullYear());
</script>
<style>

</style>
<style scoped>
.cuscd-full-wrap footer {
  background-color: transparent;
  color: #ffffff;
  /*height: 138px;*/
  padding: 2.75rem 0.938rem;
  max-width: 100%;
}
.cuscd-footer-wrap {
  display: table;
  margin: 0 auto;
  /*max-width: 21.313em;*/
  max-width: none;
  padding: 0 1rem;
  position: relative;
  text-align: center;
  width: 100%;
}
.cuscd-footer-col {
  display: table-cell;
  margin: auto;
  position: relative;
  vertical-align: top;
}
.cuscd-footer-col .cuscd-footer-img {
  width: 100%;
  margin: auto;
  display: block;
}
.cuscd-footer-col .cuscd-desc {
  color: #868686;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.025rem;
  /*max-width: 9rem;*/
  max-width: none;
  padding: 0.3rem 0.6rem;
  text-align: center;
}
.cuscd-footer-col .cuscd-desc a {
  color: #868686;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.025rem;
  max-width: 9rem;
  margin: 0.5rem;
  text-align: left;
  text-decoration: none;
}
.cuscd-footer-col .cuscd-desc-sm {
  color: #868686;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.025rem;
  max-width: none;
  padding: 0.3rem 0.6rem;
  text-align: center;
  margin-bottom: 0.5rem;
}
.cuscd-footer-col .cuscd-desc a:hover,
.cuscd-footer-col .cuscd-desc a:focus {
  text-decoration: underline;
}
.cuscd-footer-col.cuscd-single-col {
  padding: 0 3.5rem;
}
</style>
